


















import Vue from "vue";
import Tabs from "@/components/Tabs/Tabs.vue";

export default Vue.extend({
  name: "TabsTable",
  props: {
    tabs_name: {
      type: Array,
      required: true
    },
    current_tab: {
      type: String,
      required: true
    }
  },
  components: { Tabs },
  methods: {
    OnTabClick(tab: string) {
      this.$emit("click", tab);
    }
  }
});
